import { SubheadingLabel } from '@/styles/fonts'
import { GrandstandIcon } from '@grandstand-web/bally-web-shared/src/components/GrandstandIcon'
import Link from 'next/link'
import styled from 'styled-components'

const UserProfile = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 56px;
  grid-column-start: 3;
  @media (max-width: 768px) {
    grid-row-start: 1;
    grid-column-start: 2;
  }
`
const WelcomeMsg = styled(SubheadingLabel)`
  margin-right: 1rem;
  color: var(--on-background);
  @media (max-width: 375px) {
    display: none;
  }
`

export const AuthdUserProfile = ({ name }: { name?: string }) => {
  return (
    <Link href="/settings">
      <UserProfile>
        <WelcomeMsg fontSize="1">Welcome Back{name ? `, ${name}!` : '!'}</WelcomeMsg>
        <GrandstandIcon icon="account" />
      </UserProfile>
    </Link>
  )
}
